export enum problemTypes {
  ORGANIZATION = "organization",
  MAIN_ORGANIZATION = "main_organization",
  CITY = "city",
  SUBSIDIARY = "subsidiary",
  UNKNOW = "unknow"
}